import { render } from "./ReferralAdminPanel.vue?vue&type=template&id=314aa94f&scoped=true"
import script from "./ReferralAdminPanel.vue?vue&type=script&lang=js"
export * from "./ReferralAdminPanel.vue?vue&type=script&lang=js"

import "./ReferralAdminPanel.vue?vue&type=style&index=0&id=314aa94f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314aa94f"]])

export default __exports__